import "./MessageModals.scss";
import DeleteGif from "./../../assets/delete-gif.gif";
import RejectGif from "./../../assets/reject-gif.gif";
import AcceptGif from "./../../assets/accept-gif.gif";
import SuccessGif from "./../../assets/accept-gif.gif"; // Using accept gif for success too
import CloseIcon from "./../../assets/close-icon.svg";
import BlueButton from "../BlueButton/BlueButton";
import { message } from "antd";
import { FormControl, InputLabel, Modal, OutlinedInput } from "@mui/material";
import api from "../../utils/api";
import { useState, useEffect } from "react";

const MessageModals = ({
  open,
  currentView,
  onClose,
  route,
  onDataChange,
  text,
  acceptRoute,
  rejectRoute,
  acceptData,
  rejectData,
  title,
  confirmText,
  cancelText,
  onConfirm,
  loading: externalLoading,
  vendor_id,
  withReason = false, // ← NEW: pass this prop to show reason input in reject view
}) => {
  const [loading, setLoading] = useState(false);
  const [amount, setAmount] = useState("");
  const [reason, setReason] = useState(""); // ← NEW

  // Use external loading state if provided, otherwise use internal state
  const isLoading = externalLoading !== undefined ? externalLoading : loading;

  // Reset fields when modal closes
  useEffect(() => {
    if (!open) {
      setReason("");
      setAmount("");
    }
  }, [open]);

  const handleDelete = async () => {
    setLoading(true);
    try {
      await api.delete(`${route}`);
      message.success(text || "تم حذف المستخدم بنجاح");
      onDataChange && onDataChange();
    } catch (error) {
      console.error("Error deleting:", error);
    } finally {
      setLoading(false);
      onClose();
    }
  };

  const handleAccept = async () => {
    setLoading(true);
    try {
      await api.post(acceptRoute || "/action-products-requests", acceptData);
      message.success(text || "تمت الموافقة بنجاح");
      onDataChange && onDataChange();
    } catch (error) {
      console.error("Error accepting:", error);
    } finally {
      setLoading(false);
      onClose();
    }
  };

  const handleReject = async () => {
    // Only validate reason if withReason is enabled
    if (withReason && !reason.trim()) {
      message.error("الرجاء إدخال سبب الرفض");
      return;
    }

    setLoading(true);
    try {
      const payload = withReason ? { ...rejectData, reason } : rejectData;

      await api.post(rejectRoute || "/action-products-requests", payload);
      message.success(text || "تم الرفض بنجاح");
      onDataChange && onDataChange();
    } catch (error) {
      console.error("Error rejecting:", error);
    } finally {
      setLoading(false);
      onClose();
    }
  };

  const handleBalanceSettlement = async () => {
    if (!amount) {
      message.error("الرجاء إدخال المبلغ");
      return;
    }

    setLoading(true);
    try {
      await api.post(route || "/balance-settlement", {
        amount,
        vendor_id,
      });
      message.success(text || "تمت تسوية الرصيد بنجاح");
      onDataChange && onDataChange();
      setAmount("");
    } catch (error) {
      console.error("Error settling balance:", error);
      message.error("حدث خطأ أثناء تسوية الرصيد");
    } finally {
      setLoading(false);
      onClose();
    }
  };

  const renderDeleteView = () => (
    <div className="container">
      <div className="header" onClick={onClose}>
        <img src={CloseIcon} alt="" />
      </div>
      <div className="body">
        <img src={DeleteGif} alt="" />
        <h4>هل أنت متأكد من الحذف</h4>
      </div>
      <div className="footer">
        <BlueButton
          text="حذف"
          onClick={handleDelete}
          size="medium"
          variant="fill"
          loading={isLoading}
        />
      </div>
    </div>
  );

  const renderRejectView = () => (
    <div className="container">
      <div className="header" onClick={onClose}>
        <img src={CloseIcon} alt="" />
      </div>
      <div className="body">
        <img src={RejectGif} alt="" />
        <h4>هل أنت متأكد من الرفض</h4>
      </div>

      {/* ← Only shown when withReason prop is true */}
      {withReason && (
        <FormControl sx={{ width: "100%", mt: 1 }} variant="outlined">
          <InputLabel
            htmlFor="reject-reason"
            shrink
            sx={{
              background: "white",
              transformOrigin: "right top",
              transform: "translate(14px, -9px) scale(0.75)",
              right: 24,
              left: "auto",
              paddingLeft: "4px",
              paddingRight: "4px",
            }}
          >
            سبب الرفض
          </InputLabel>
          <OutlinedInput
            id="reject-reason"
            multiline
            rows={3}
            notched
            placeholder="اكتب سبب الرفض..."
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            sx={{ borderRadius: "8px" }}
          />
        </FormControl>
      )}

      <div className="footer">
        <BlueButton
          text="تاكيد"
          onClick={handleReject}
          size="medium"
          variant="fill"
          loading={isLoading}
        />
      </div>
    </div>
  );

  const renderAcceptView = () => (
    <div className="container">
      <div className="header" onClick={onClose}>
        <img src={CloseIcon} alt="" />
      </div>
      <div className="body">
        <img src={AcceptGif} alt="" />
        <h4>هل أنت متأكد من الموافقة</h4>
      </div>
      <div className="footer">
        <BlueButton
          text="تاكيد"
          onClick={handleAccept}
          size="medium"
          variant="fill"
          loading={isLoading}
        />
      </div>
    </div>
  );

  const renderWithdrawalView = () => (
    <div
      className="container"
      style={{ justifyContent: "space-between", padding: "24px 10px" }}
    >
      <div className="header" onClick={onClose}>
        <img src={CloseIcon} alt="" />
      </div>

      <h3>{title || "تسوية الرصيد"}</h3>
      <FormControl sx={{ width: "100%", padding: "0px" }} variant="outlined">
        <InputLabel
          htmlFor="outlined-adornment-amount"
          shrink
          sx={{
            background: "white",
            transformOrigin: "right top",
            transform: "translate(14px, -9px) scale(0.75)",
            right: 24,
            left: "auto",
            paddingLeft: "4px",
            paddingRight: "4px",
          }}
        >
          المبلغ
        </InputLabel>
        <OutlinedInput
          sx={{ borderRadius: "8px" }}
          required
          id="outlined-adornment-amount"
          type="number"
          notched
          placeholder="اكتب المبلغ"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
        />
      </FormControl>

      <div className="footer">
        <BlueButton
          text="تاكيد"
          onClick={handleBalanceSettlement}
          size="medium"
          variant="fill"
          loading={isLoading}
        />
      </div>
    </div>
  );

  const renderConfirmView = () => (
    <div className="container">
      <div className="header" onClick={onClose}>
        <img src={CloseIcon} alt="" />
      </div>
      <div className="body">
        <img src={RejectGif} alt="" />
        <h4>{title || "تأكيد"}</h4>
        <p>{text || "هل أنت متأكد؟"}</p>
      </div>
      <div className="footer" style={{ display: "flex", gap: "10px" }}>
        <BlueButton
          text={confirmText || "تاكيد"}
          onClick={onConfirm}
          size="medium"
          variant="fill"
          loading={isLoading}
        />
        <BlueButton
          text={cancelText || "إلغاء"}
          onClick={onClose}
          size="medium"
          variant="outlined"
          disabled={isLoading}
        />
      </div>
    </div>
  );

  const renderSuccessView = () => (
    <div className="container">
      <div className="header" onClick={onClose}>
        <img src={CloseIcon} alt="" />
      </div>
      <div className="body">
        <img src={SuccessGif} alt="" />
        <h4>{title || "نجاح"}</h4>
        <p>{text || "تمت العملية بنجاح"}</p>
      </div>
      <div className="footer">
        <BlueButton
          text="إغلاق"
          onClick={onClose}
          size="medium"
          variant="fill"
        />
      </div>
    </div>
  );

  const renderDefaultView = () => (
    <div className="container">
      <div className="header" onClick={onClose}>
        <img src={CloseIcon} alt="" />
      </div>
      <div className="body">
        <h4>Default View</h4>
        <p>No specific view was selected.</p>
      </div>
      <div className="footer">
        <BlueButton
          text="Close"
          onClick={onClose}
          size="medium"
          variant="fill"
        />
      </div>
    </div>
  );

  const views = {
    delete: renderDeleteView,
    reject: renderRejectView,
    accept: renderAcceptView,
    withdrawal: renderWithdrawalView,
    confirm: renderConfirmView,
    success: renderSuccessView,
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      className="message-modal"
    >
      {(views[currentView] || renderDefaultView)()}
    </Modal>
  );
};

export default MessageModals;
